import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { primeraRutaPermitida } from '../layout/navegacion';
import { PermissionsService } from '../services/permissions.service';
import { Permiso } from './permisos';

/**
 * Exige el permiso declarado en `data.permiso` de la ruta (uno o una lista:
 * con ALGUNO basta). Si el usuario no lo tiene, lo manda a su primera pantalla
 * permitida (o a /sin-acceso si no tiene ninguna). Se apoya en que `authGuard`
 * ya garantizó la sesión.
 */
export const permisoGuard: CanActivateFn = (route) => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);

  const permiso = route.data['permiso'] as Permiso | Permiso[] | undefined;
  const requeridos = Array.isArray(permiso) ? permiso : [permiso];
  if (requeridos.some((p) => permissions.can(p))) {
    return true;
  }
  const destino = primeraRutaPermitida((p) => permissions.can(p));
  return router.createUrlTree([destino ?? '/sin-acceso']);
};
